import { type ReactNode } from "react";

import { usePushNotificationRegistration } from "./hooks/usePushNotificationRegistration";

interface PushNotificationProviderProps {
  children: ReactNode;
}

/**
 * Provider that handles push notification registration.
 * Registers the device for push notifications and sends the token to the backend.
 * Must be mounted inside the authenticated app tree (requires userId from session).
 *
 * Handler hooks for notification display and deep links will be wired in a follow-up ticket (2b).
 */
export function PushNotificationProvider(props: PushNotificationProviderProps) {
  const { children } = props;

  usePushNotificationRegistration();

  return <>{children}</>;
}
